import { useQuery } from "@apollo/client/react";

import { inboxOwnedTeams } from "./ownedTeams.graphql";
import { ownedTeamIds, type OwnedMembership } from "./ownedTeams";

type OwnedTeamsQuery = {
  userPerson?: {
    memberships?: OwnedMembership[] | null;
  } | null;
};

export const useInboxOwnedTeamIds = (enabled: boolean): string[] => {
  const { data } = useQuery<OwnedTeamsQuery>(inboxOwnedTeams, {
    skip: !enabled,
  });
  return ownedTeamIds(data?.userPerson?.memberships);
};
